import { createComponent } from '@mtfe/sweet';
import { CouponListD, Draw, componentUtils } from '@mtfe/sweet-components';
import { common, eventBus, createDeepLink } from '@mtfe/sweet-utils';
import tpl from './dom.html';
import style from './style.less';
import store from '../../store';
import http from '../../service';
import { useAutoLogin, clickToReport } from '../../utils';
import { filterNewCoupon } from '../../utils/filter';
import { fetchAllCoupon } from '../../utils/fetchData';
import WaimaiDrawBody from '../WaimaiDrawBody/script';
import { COUPON_STATUS } from '../../constants';
import InnerPoi from '../common/InnerPoi/script';
import { renderPoiInfoG } from '../../utils/renderPoi';

const { storeCommon } = store;
const { debounceByPromise } = common;
const { getOnClickEventName } = componentUtils;
const deepLink = createDeepLink();

const WaimaiCrazyCouponListReady = (couponListObj) => {
    eventBus.$onceOn('WaimaiCrazyCouponListReady', async () => {
        couponListObj.ready();
    });
};

const WaimaiCrazyCouponList = (props = {}) => {
    const { welfareIndex = '福利' } = props;
    const { structInfo } = storeCommon;
    const {
        dom_wm_red_bag: domWmRedBag,
        dom_wm_every_day_coupon: domWmEveryDayCoupon,
    } = structInfo.struct;

    const storeWmEveryDayCoupon = store[domWmEveryDayCoupon.recallBizId];
    const storeWmRedBag = store[domWmRedBag.recallBizId];

    const couponList = [];
    let giftValue = 0;
    let couponListObj = null;

    storeWmRedBag.discountData.redBagList.forEach((poiInfo) => {
        const {
            poiData,
            coupon_amount: couponAmount,
            order_amount_limit: orderAmountLimit,
        } = poiInfo.giftInfo;

        const poiListDom = InnerPoi({ poiData, renderFunc: renderPoiInfoG });
        poiInfo.draw = new Draw(
            WaimaiDrawBody({
                value: couponAmount / 100,
                threshold: orderAmountLimit / 100,
                poiListDom,
                isShangouModule: false,
            }),
        );
        const node = document.createElement('div');
        node.innerHTML = poiInfo.draw.getComponent();
        document.body.appendChild(node);
    });

    if (storeWmRedBag.isShow) {
        couponList.push(...storeWmRedBag.discountData.redBagList);
        giftValue += storeWmRedBag.discountData.giftValue;
    }
    if (storeWmEveryDayCoupon.isShow) {
        couponList.push(...storeWmEveryDayCoupon.discountData.couponList);
        giftValue += storeWmEveryDayCoupon.discountData.giftValue;
    }

    const onGetAllCouponsClickHandler = async () => {
        // 这个数组必须定义在领券之前
        const newCouponPoiList = filterNewCoupon(couponList);
        try {
            await fetchAllCoupon(couponList, storeWmEveryDayCoupon.recallBizId);
            couponListObj.render();
            couponListObj.ready();
        } catch (error) {
            console.error(error);
        }
        // 领券之后，带参数上报商家的点击
        // 领券失败也要上报
        const componentId = couponListObj.describe
            .getSubComponent('ReceiveAll')
            .getComponentID();

        newCouponPoiList.forEach((poiInfoOfNewCouponList) => {
            clickToReport(poiInfoOfNewCouponList, componentId);
        });
    };
    const onCouponClickHandler = async (poiInfo) => {
        const { giftInfo, draw } = poiInfo;
        const { gift_id: giftId } = giftInfo;
        const canReceive = giftInfo.status === COUPON_STATUS.STATUS_NEW;
        if (canReceive) {
            try {
                await fetchAllCoupon(
                    couponList,
                    storeWmEveryDayCoupon.recallBizId,
                );
                const componentId = couponListObj.describe
                    .getSubComponent('Coupon')
                    .getComponentID();
                clickToReport(poiInfo, componentId);
            } catch (error) {
                console.error(error);
            }
        } else {
            if (draw) {
                draw.onOpenDraw(() => {
                    const onClickEventName = getOnClickEventName(
                        storeWmRedBag.recallBizId,
                        giftId,
                    );
                    eventBus.$emit(onClickEventName);
                });
            } else {
                deepLink.gotoDp(poiInfo.dpUrl, poiInfo.lpUrl, () => {
                    clickToReport(poiInfo);
                });
            }
        }
    };

    couponListObj = new CouponListD({
        couponList,
        giftValue,
        isMonitorCoupons: true,
        http,
        isShowSmall: true,
        onCouponClick: debounceByPromise(
            useAutoLogin(onCouponClickHandler),
            500,
            true,
        ),
        onGetAllCouponsClick: debounceByPromise(
            useAutoLogin(onGetAllCouponsClickHandler),
            500,
            true,
        ),
    });

    const data = {
        couponListDom:
            couponList.length > 0 ? couponListObj.getComponent() : '',
        welfareIndex,
    };
    const events = {};
    WaimaiCrazyCouponListReady(couponListObj);
    const component = createComponent(tpl, { data, style }, events);
    return component;
};

export default WaimaiCrazyCouponList;
